export default __webpack_public_path__ + "static/sitemap-title-80efd25697e9ef0ede58fd5d384b8732.png";